export default "__VITE_ASSET__e1ff6067__"